(() => {
  'use strict';
  if (window.WerlarProduct) return;
  const controllers = new WeakMap();
  function roots(scope) {
    return [...(scope.matches?.('[data-wr-product-root]') ? [scope] : []), ...scope.querySelectorAll('[data-wr-product-root]')];
  }
  function initialize(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    controllers.set(root, controller);
    function listen(target, type, callback, options = {}) {
      target.addEventListener(type, callback, { ...options, signal: controller.signal });
    }

 const form=root.querySelector('.wrp-form');if(!form)return;
 const variantsScript=document.getElementById('WerlarVariants-'+root.dataset.sectionId);
 const variants=JSON.parse(variantsScript&&variantsScript.textContent||'[]');
 const idInput=form.querySelector('[data-variant-id]');
 const prices=[...root.querySelectorAll('[data-product-price]')];
 const add=form.querySelector('[name=add]');
 const stickyBar=root.querySelector('[data-wr-mobile-product-bar]');
 const stickyPrice=stickyBar&&stickyBar.querySelector('[data-sticky-product-price]');
 const stickyAdd=stickyBar&&stickyBar.querySelector('[data-sticky-add]');
 const stickyWhatsApp=stickyBar&&stickyBar.querySelector('[data-sticky-whatsapp]');
 const primaryActions=root.querySelector('[data-primary-purchase-actions]');
 const mobileMedia=window.matchMedia('(max-width: 760px)');
 const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
 const gallery=root.querySelector('.wrp-gallery');
 const mainMedia=root.querySelector('.wrp-main-media');
 let selectedVariant=variants.find(v=>v.id===Number(idInput.value))||variants[0];
 let scrollTicking=false;
 let lightboxReturnFocus=null;

 /* Product links must always open at the beginning of the product page. */
 function resetProductPagePosition(){
   if(window.location.hash)return;
   window.scrollTo({top:0,left:0,behavior:'auto'});
 }
 if('scrollRestoration' in window.history)window.history.scrollRestoration='manual';
 if(!window.Shopify?.designMode){resetProductPagePosition();window.requestAnimationFrame(resetProductPagePosition);}
 listen(window,'load',()=>{
   if(!window.Shopify?.designMode)resetProductPagePosition();
 },{once:true});

 function money(c){return new Intl.NumberFormat(undefined,{style:'currency',currency:root.dataset.currency}).format(c/100)}
 function getHeaderOffset(){
   const value=Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wr-visible-header-height'))||0;
   return Math.max(0,value)+12;
 }
 function scrollToProductMedia(){
   const target=mainMedia||gallery;
   if(!target)return;
   const top=Math.max(0,window.scrollY+target.getBoundingClientRect().top-getHeaderOffset());
   window.scrollTo({top,left:0,behavior:reducedMotion.matches?'auto':'smooth'});
 }
 function findMedia(mediaId,imageId){
   const items=[...root.querySelectorAll('.wrp-media')];
   return items.find(item=>mediaId&&String(item.dataset.mediaId)===String(mediaId))
     ||items.find(item=>imageId&&String(item.dataset.imageId)===String(imageId))
     ||null;
 }
 function activeMedia(mediaId,imageId,scrollAfterChange){
   const target=findMedia(mediaId,imageId);
   if(!target)return false;
   root.querySelectorAll('.wrp-media').forEach(item=>{
     const active=item===target;
     item.classList.toggle('is-active',active);
     item.setAttribute('aria-hidden',active?'false':'true');
     if(!active)item.querySelectorAll('video').forEach(video=>video.pause&&video.pause());
   });
   root.querySelectorAll('.wrp-thumb').forEach(item=>{
     const active=(mediaId&&String(item.dataset.mediaId)===String(mediaId))||(imageId&&String(item.dataset.imageId)===String(imageId));
     item.classList.toggle('is-active',Boolean(active));
     item.setAttribute('aria-pressed',active?'true':'false');
   });
   const image=target.querySelector('img');
   if(image&&image.loading==='lazy')image.loading='eager';
   if(scrollAfterChange)window.requestAnimationFrame(scrollToProductMedia);
   return true;
 }
 root.querySelectorAll('.wrp-media').forEach((item,index)=>item.setAttribute('aria-hidden',index===0?'false':'true'));
 root.querySelectorAll('.wrp-thumb').forEach((button,index)=>{
   button.setAttribute('aria-pressed',index===0?'true':'false');
   listen(button,'click',()=>activeMedia(button.dataset.mediaId,button.dataset.imageId,false));
 });

 function syncWhatsApp(v){
   const wa=form.querySelector('[data-product-whatsapp]');
   if(!wa)return;
   const variantText=(v.title&&v.title!=='Default Title')?' - '+v.title:'';
   const custom=(wa.dataset.waMessage||'').trim();
   const message=(custom||('Hi Werlar, I am interested in '+wa.dataset.productTitle))+variantText+'. Product link: '+wa.dataset.productUrl;
   const href=wa.dataset.waBase+'?text='+encodeURIComponent(message);
   wa.href=href;
   if(stickyWhatsApp)stickyWhatsApp.href=href;
 }
 function updateVariantUrl(v){
   try{
     const url=new URL(window.location.href);
     url.searchParams.set('variant',v.id);
     window.history.replaceState({variantId:v.id},'',url.toString());
   }catch(_error){/* URL updates are optional. */}
 }
 function update(fromUser){
   const opts=[...form.querySelectorAll('input[name^="options"]:checked')].map(x=>x.value);
   const v=opts.length?variants.find(x=>x.options.every((o,i)=>o===opts[i])):(variants.find(x=>x.id===Number(idInput.value))||variants[0]);
   if(!v){
     idInput.value='';
     add.disabled=true;add.textContent='Unavailable combination';
     if(stickyAdd){stickyAdd.disabled=true;stickyAdd.textContent='Unavailable';}
     const status=root.querySelector('[data-product-availability]');
     if(status)status.textContent='This option combination is unavailable';
     return;
   }
   selectedVariant=v;
   idInput.value=v.id;
   prices.forEach(element=>element.textContent=money(v.price));
   const compare=root.querySelector('[data-product-compare-price]');
   if(compare){compare.hidden=!(v.compare_at_price>v.price);compare.textContent=compare.hidden?'':money(v.compare_at_price);}
   const status=root.querySelector('[data-product-availability]');
   if(status)status.textContent=v.available?'Available to order':'Currently unavailable';
   if(stickyPrice)stickyPrice.textContent=money(v.price);
   add.disabled=!v.available;
   add.textContent=v.available?'Add to cart':'Sold out';
   if(stickyAdd){stickyAdd.disabled=!v.available;stickyAdd.textContent=v.available?root.dataset.mobileAddLabel:'Sold out'}
   if(v.featured_media_id||v.featured_image_id)activeMedia(v.featured_media_id,v.featured_image_id,Boolean(fromUser));
   updateVariantUrl(v);
   syncWhatsApp(v);
 }
 form.querySelectorAll('input[name^="options"]').forEach(input=>listen(input,'change',()=>update(true)));

 const quantity=form.querySelector('input[name=quantity]');
 const minus=form.querySelector('[data-qty-minus]');
 const plus=form.querySelector('[data-qty-plus]');
 if(minus)listen(minus,'click',()=>quantity.value=Math.max(1,(Number.parseInt(quantity.value,10)||1)-1));
 if(plus)listen(plus,'click',()=>quantity.value=Math.max(1,(Number.parseInt(quantity.value,10)||1)+1));
 if(stickyAdd)listen(stickyAdd,'click',()=>{if(!stickyAdd.disabled)form.requestSubmit(add)});

 const lightbox=root.querySelector('.wrp-lightbox');
 const lightboxImage=lightbox&&lightbox.querySelector('img');
 function openLightbox(button){
   if(!lightbox||!lightboxImage)return;
   lightboxReturnFocus=button;
   lightboxImage.src=button.dataset.zoom;
   lightbox.classList.add('is-open');
   lightbox.setAttribute('aria-hidden','false');
   lightbox.querySelector('button').focus();
   document.body.classList.add('wr-overlay-open');
 }
 function closeLightbox(){
   if(!lightbox)return;
   lightbox.classList.remove('is-open');
   lightbox.setAttribute('aria-hidden','true');
   document.body.classList.toggle('wr-overlay-open',Boolean(document.querySelector('.wr-search-drawer.is-open,.wr-cart-drawer.is-open,.wr-mobile-drawer.is-open')));
   if(lightboxReturnFocus)lightboxReturnFocus.focus();
 }
 root.querySelectorAll('.wrp-zoom').forEach(button=>listen(button,'click',()=>openLightbox(button)));
 if(lightbox){
   lightbox.querySelector('button').addEventListener('click',closeLightbox);
   listen(lightbox,'click',event=>{if(event.target===lightbox)closeLightbox()});
   listen(document,'keydown',event=>{if(!lightbox.classList.contains('is-open'))return;if(event.key==='Escape')closeLightbox();if(event.key==='Tab'){event.preventDefault();lightbox.querySelector('button').focus()}});
 }

 function updateStickyBar(){
   if(!stickyBar||!primaryActions)return;
   const rect=primaryActions.getBoundingClientRect();
   const show=mobileMedia.matches&&rect.bottom<8&&window.scrollY>120;
   stickyBar.classList.toggle('is-visible',show);
   stickyBar.setAttribute('aria-hidden',show?'false':'true');
   document.body.classList.toggle('wr-mobile-action-visible',show);
   scrollTicking=false;
 }
 if(stickyBar&&primaryActions){
   listen(window,'scroll',()=>{if(!scrollTicking){scrollTicking=true;requestAnimationFrame(updateStickyBar)}},{passive:true});
   listen(window,'resize',updateStickyBar,{passive:true});
   mobileMedia.addEventListener&&listen(mobileMedia,'change',updateStickyBar);
   updateStickyBar();
 }

 const tabs=root.querySelector('.wrp-tabs');
 if(tabs){
   const strip=tabs.querySelector('.wr-container');
   const links=[...tabs.querySelectorAll('a[href^="#"]')];
   const sections=links.map(link=>root.querySelector(link.getAttribute('href'))).filter(Boolean);
   let activeId='';
   let ticking=false;
   function keepActiveTabVisible(link){
     if(!strip||!link)return;
     const stripRect=strip.getBoundingClientRect();
     const linkRect=link.getBoundingClientRect();
     if(linkRect.left<stripRect.left)strip.scrollBy({left:linkRect.left-stripRect.left-12,behavior:reducedMotion.matches?'auto':'smooth'});
     else if(linkRect.right>stripRect.right)strip.scrollBy({left:linkRect.right-stripRect.right+12,behavior:reducedMotion.matches?'auto':'smooth'});
   }
   function setActive(id){
     if(!id||id===activeId)return;
     activeId=id;
     links.forEach(link=>{
       const active=link.getAttribute('href')==='#'+id;
       link.classList.toggle('is-active',active);
       if(active){link.setAttribute('aria-current','true');keepActiveTabVisible(link)}else link.removeAttribute('aria-current');
     });
   }
   function updateActiveFromScroll(){
     const offset=tabs.getBoundingClientRect().height+Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wr-visible-header-height')||0)+24;
     let current=sections[0];
     for(const section of sections){if(section.getBoundingClientRect().top<=offset)current=section;else break}
     if(current)setActive(current.id);
     ticking=false;
   }
   links.forEach(link=>link.addEventListener('click',()=>setActive(link.getAttribute('href').slice(1))));
   if(sections.length){
     setActive(sections[0].id);
     listen(window,'scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(updateActiveFromScroll)}},{passive:true});
     listen(window,'resize',updateActiveFromScroll,{passive:true});
     updateActiveFromScroll();
   }
 }
 update(false);

  }
  window.WerlarProduct = {
    init(scope = document) { roots(scope).forEach(initialize); },
    destroy(scope) {
      roots(scope).forEach(root => { controllers.get(root)?.abort(); controllers.delete(root); });
      document.body.classList.remove('wr-mobile-action-visible');
    }
  };
})();
